import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-layout-board-split"
      width={props.width || 20}
      height={props.height || 20}
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke={props.fill || '#fff'}
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M4 12h8" />
      <path d="M12 15h8" />
      <path d="M12 9h8" />
      <path d="M12 4v16" />
    </svg>
  )
}
const BoardSplitIcon = (props) => {
  const { width, height, fill } = props
  return (
    // <MorphReplace width={width} height={height} fill={fill}>
    <Icon width={width} height={height} fill={fill} />
    // {/* </MorphReplace> */}
  )
}

// 默认参数
BoardSplitIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#fff',
}
// 参数类型
BoardSplitIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default BoardSplitIcon
